import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import type { ContractRouterClient } from '@orpc/contract';
import { createTanstackQueryUtils } from '@orpc/tanstack-query';
import type { Contract } from '@ticketai/contract';

// Same origin: the session cookie travels automatically, no CORS involved.
const link = new RPCLink({ url: `${window.location.origin}/api/rpc` });

/** Typed client for the whole API (PLAN.md §5.1). The SPA has no other way to reach the server. */
export const client: ContractRouterClient<Contract> = createORPCClient(link);

/** TanStack Query helpers: `useQuery(orpc.system.health.queryOptions())`. */
export const orpc = createTanstackQueryUtils(client);
